// MarketsPageSkeleton - Loading state for markets page
import { Box, Skeleton } from '@mui/material';

import { MarketCardSkeleton } from '../../common';

const SKELETON_ITEMS = [1, 2, 3, 4, 5, 6, 7, 8];

const MarketCardSkeletonItem = ({ itemKey }: { itemKey: number }) => (
  <MarketCardSkeleton key={itemKey} />
);

export const MarketsSkeleton = () => {
  return (
    <Box sx={{ py: { xs: 1, sm: 2 } }}>
      {/* Mirrors Topbar: h4 title + body2 subtitle */}
      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Skeleton variant="text" width={140} height={38} />
        <Skeleton variant="text" width={220} height={20} sx={{ mt: 0.5 }} />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gap: { xs: 1.5, sm: 2 },
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
        }}
      >
        {SKELETON_ITEMS.map((itemKey) => (
          <MarketCardSkeletonItem key={itemKey} itemKey={itemKey} />
        ))}
      </Box>
    </Box>
  );
};

export default MarketsSkeleton;
